<template>
  <div
    v-if="computedData?.elements?.length > 0"
    class="block-accordion"
    :class="`block-accordion--${computedData.theme}`"
    :theme="computedData.theme"
  >
    <div class="block-accordion__inner">
      <div v-if="computedData.title" class="block-accordion__title">
        <AtomHeading tag="h3" appereance="h3" :text="computedData.title" />
      </div>
      <div class="block-accordion__content">
        <BlockAccordionElement
          v-for="(element, index) in computedData.elements"
          :key="element._uid"
          :data="element"
          :accordion-index="index"
          :accordion-active-index="accordionActiveIndex"
          :theme="computedData.theme"
          :strapi-data-key="computedData.strapiDataKey"
          @set-accordion-active-index="setAccordionActiveIndex"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const accordionActiveIndex = ref(-1);
const setAccordionActiveIndex = (index) => {
    accordionActiveIndex.value = index;
};

const computedData = computed(() => {
    if (props.data) {
        let { title, theme } = props.data;
        let elements = props.data.accordion_element;
        let strapiDataKey = '';

        if (props.data?.strapi_data_key) {
            const storyStore = useStoryStore();
            const strapiData = props.data.strapi_data_key;

            title = storyStore.getConnectedStrapiValue(strapiData)?.title;
            elements = storyStore.getConnectedStrapiValue(strapiData)?.accordion_element;
            theme = storyStore.getConnectedStrapiValue(strapiData)?.theme;
            strapiDataKey = strapiData;
        }

        return {
            title,
            elements,
            theme,
            strapiDataKey,
        };
    }

    return {};
});

</script>

<style lang="scss">
.block-accordion {
    @include component-spacing(30px, 60px);
    @include grid-layout();
    @include grid-columns();

    & + .block-information-cards {
        @include fluid('margin-top', 20px, 40px);
    }
}

.block-accordion__title {
    margin-bottom: 40px;

    .atom-heading {
        margin-bottom: 0;
    }
}

.block-accordion__inner {
    @include grid-columns(3, 14);
}

.block-accordion--secondary {
    @include fluid('padding-top', 20px, 50px);
    @include fluid('padding-bottom', 20px, 50px);
    @include grid-columns(3, 14);

    border-radius: 12px;
    background-color: $C_GREY;

    .block-accordion__inner {
        @include grid-columns(2, 16);

        @include tablet{
            @include grid-columns(2, 10);
        }

        @include mobile {
            width: 100%;
            max-width: var(--grid-width);
            padding-right: var(--page-padding);
            padding-left: var(--page-padding);
        }
    }

    @include tablet {
        @include grid-columns(2, 10);
    }
}
</style>
